import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  SpinningLogo,
  FrameArrayRender,
  ImageArrayRender,
  SEO,
} from "../components";
import { IonRow } from "@ionic/react";
import { sortByDate } from "../helpers/helpers";
import { useSpotifyAccessToken, useReleaseData } from "../hooks/useReleaseData";
import { useMixData } from "../hooks/useMixData";

export const Home = (props) => {
  const { config, project } = props;
  const [loading, setLoading] = useState(true);
  const [logoLoaded, setLogoLoaded] = useState(false);

  const accessToken = useSpotifyAccessToken();
  const artistId = config?.artistId;
  const releases = useReleaseData(artistId, accessToken);
  const sortedReleases = sortByDate(releases);
  const latestReleases = sortedReleases?.slice(0, 3);
  const sheetId = config?.googleSheetId;
  const seo = config?.SEO.homepage;

  const mixData = useMixData(sheetId);
  const latestMixes = mixData?.slice(0, 3);

  const className = "logos-home";

  const isReleasesReady = latestReleases && latestReleases.length > 0;
  const isMixesReady = latestMixes && latestMixes.length > 0;

  useEffect(() => {
    if ((isReleasesReady || isMixesReady) && logoLoaded) {
      setLoading(false);
    }
  }, [isReleasesReady, isMixesReady, logoLoaded]);

  const handleLogoLoaded = () => {
    setLogoLoaded(true);
  };

  return (
    <>
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />
      <div id="HomePage" className="home-page">
        <div className={`home-image-div ${config?.media.image}`}>
          <SpinningLogo
            className={`${className} ${loading ? "is-loading" : ""}`}
            logos={config.logos}
            onLoaded={handleLogoLoaded}
          />
        </div>

        {!loading && (
          <div className="music-page">
            <div className="music-container">
              <ImageArrayRender
                data={latestReleases}
                pageTitle={"LATEST RELEASES"}
                project={project}
                loading={false}
              />
              <IonRow className="flex-center">
                <NavLink
                  to={`/${project}/discography`}
                  className="flashing-btn"
                >
                  <div className="link-text-home btn-shine">
                    COMPLETE DISCOGRAPHY
                  </div>
                </NavLink>
              </IonRow>
              <FrameArrayRender data={latestMixes} pageTitle={"LATEST MIXES"} />
              <IonRow className="flex-center">
                <NavLink to={`/${project}/mixes`} className="flashing-btn">
                  <div className="link-text-home btn-shine">ALL MIXES</div>
                </NavLink>
              </IonRow>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
